<script>
    export default {
        methods: {
            onDelete(event) {
                if (confirm('Are you sure?')) {
                    this.$refs.form.submit();
                    return;
                }

                event.preventDefault();
                event.stopPropagation();
            }
        },
    };
</script>
